// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"oO-z","categoryName":"pO-z","categoryNameSearchHeader":"qO-z","categoryContent":"rO-z","bottomAligned":"sO-z","image":"tO-z","imageNoBackground":"uO-z"};